(function () {
  if (window.TFCollectionNavigationReady) return;
  window.TFCollectionNavigationReady = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-tf-nav-card]');
    if (!link) return;

    var section = link.closest('[data-tf-collection-header]');
    var detail = {
      navigation_type: link.getAttribute('data-tf-nav-card'),
      collection_handle: section ? section.getAttribute('data-collection-handle') : '',
      collection_title: section ? section.getAttribute('data-collection-title') : '',
      link_text: link.textContent.replace(/\s+/g, ' ').trim(),
      destination_path: link.pathname
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'collection_navigation_click' }, detail));
    document.dispatchEvent(new CustomEvent('tf:collection-navigation', { detail: detail }));
  });
})();
